var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMenu),expression:"showMenu"}],staticClass:"menu",style:({
      left: (_vm.x + "px"),
      top: (_vm.y + "px")
    })},[_c('span',{staticClass:"item",on:{"mousedown":function($event){$event.preventDefault();_vm.handleAction('annotate')}}},[_vm._v("\n      Annotate\n    ")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }